<main
  *ngIf="isDesktopHandoff"
  class="identity-verification-handoff"
  aria-labelledby="handoff-title"
>
  <section
    class="identity-verification-handoff__content"
    role="status"
    aria-live="polite"
  >
    <span class="identity-verification-handoff__icon" aria-hidden="true"
      >✓</span
    >
    <h1 id="handoff-title">Verification complete</h1>
    <p>Return to the device where you started verification to continue.</p>
  </section>
</main>
